const pageNames = [
  {
    key: "personal",
    value: "basic_details",
  },
  {
    key: "sign",
    value: "signature",
  },
  {
    key: "credit",
    value: "credit_check_analysis",
  },
  {
    key: "questions",
    value: "question_page",
  },
  // {
  //   key: "questionsV2",
  //   value: "question_page_UFC_DC_V2",
  // },
  {
    key: "edit",
    value: "edit_details",
  },
  {
    key: "prevaddress",
    value: "previous_address",
  },
  {
    key: "verify",
    value: "person_verify",
  },
  {
    key: "preview",
    value: "preview_page",
  },
  {
    key: "id",
    value: "id_upload",
  },
  {
    key: "thankyou",
    value: "thankyou_page",
  },
  {
    key: "credit_confirm",
    value: "credit_confirm",
  },
  {
    key: "credit_check_question_UFC_DC_V3",
    value: "credit_check_question_UFC_DC_V3",
  },
  {
    key: "credit_check_question_MOCK_OD",
    value: "credit_check_question_MOCK_OD",
  },
  {
    key: "credit_check_question_UFC_DC_V4",
    value: "credit_check_question_UFC_DC_V4",
  },
  {
    key: "consents_page",
    value: "consents_page",
  },
  {
    key: "thankyou",
    value: "thankyou",
  },
  {
    key: "credit_check_question_FLP_OD_V2",
    value: "consents_page",
  },
  {
    key: "flp_OD_lp_visited",
    value: "flp_OD_lp_visited",
  },
  {
    key: "flp_OD_proceed_btn_click",
    value: "flp_OD_proceed_btn_click",
  },
  {
    key: "T2A",
    value: "T2A",
  },
  
  {
    key: "consents_page",
    value: "consents_page",
  },
  {
    key: "thankyou",
    value: "thankyou",
  },
  {
    key: "merit_page",
    value: "merit_page",
  },
  {
    key: "signature_preview",
    value: "signature_preview",
  },
  {
    key: "flp_sign_reconfirm_lp_visited",
    value: "flp_sign_reconfirm_lp_visited",
  },
  {
    key: "flp_sign_reconfirm_proceed_btn_click",
    value: "flp_sign_reconfirm_proceed_btn_click",
  },
  {
    key: "flp_sign_reconfirm_signature",
    value: "flp_sign_reconfirm_signature",
  },
  {
    key: "thankyou_flp_reconfirm_sign",
    value: "thankyou_flp_reconfirm_sign",
  },
  {
    key: "flp_sign_for_prev_signature",
    value: "flp_sign_for_prev_signature",
  },
  {
    key: "T2A",
    value: "T2A",
  },
  {
    key: "thankyou-bl",
    value: "thankyou-bl",
  },
  {
    key: "ThankyouOD_V2",
    value: "ThankyouOD_V2",
  },
  {
    key: "re_engage_loader",
    value: "re_engage_loader",
  },
  {
    key: "re_engage_cc_intro",
    value: "re_engage_cc_intro",
  },
   {
    key: "re_engage_hp_intro",
    value: "re_engage_hp_intro",
  },
  {
    key: "re_engage_cc_question",
    value: "re_engage_cc_question",
  },

  {
    key: "re_engage_cc_meritpage",
    value: "re_engage_cc_meritpage",
  },
  {
    key: "re_engage_cc_signature",
    value: "re_engage_cc_signature",
  }, 
  {
    key: "re_engage_cc_previewpage",
    value: "re_engage_cc_previewpage",
  },
  {
    key: "re_engage_cc_thankyou",
    value: "re_engage_cc_thankyou",
  },
  {
    key: "re_engage_hp_question",
    value: "re_engage_hp_question",
  },

  {
    key: "re_engage_hp_meritpage",
    value: "re_engage_hp_meritpage",
  },
  {
    key: "re_engage_hp_signature",
    value: "re_engage_hp_signature",
  }, 
  {
    key: "re_engage_hp_previewpage",
    value: "re_engage_hp_previewpage",
  },
  {
    key: "re_engage_hp_thankyou",
    value: "re_engage_hp_thankyou",
  },
  
];


export const getPageName = (key) => {
  return pageNames.find((page) => page.key === key)?.value;
};
